import { BubbleGameBoard } from 'js/bubbleCore/BubbleGameBoard';
import { BubbleGameBoardView } from 'js/bubbleCore/view/BubbleGameBoardView';
import { ICoords } from 'js/bubbleCore/view/InputCatcher';
import { IPoint, getAngle } from 'framework/utils/math-utils';
import { EventType } from 'js/bubbleCore/events';

interface IControllerConfig {
  onGameOver: () => Promise<void>;
  mobile: boolean;
}

export class Controller {
  private readonly board: BubbleGameBoard;
  private readonly view: BubbleGameBoardView;

  constructor(board: BubbleGameBoard, view: BubbleGameBoardView, config: IControllerConfig) {
    this.board = board;
    this.view = view;

    const inputCatcher = this.view.getInputCatcher();

    (
      config.mobile ?
      inputCatcher.signals.onPointerUp : 
      inputCatcher.signals.onPointerDown
    ).add((coords: ICoords) => {
      this.handlePointerDown(coords);
    });

    const binding = this.board.signals.onEventProcessed.add((event) => {
      if (event.type !== EventType.DeathLineCrossed) return;
      config.onGameOver();
      binding.detach();
    });
  }

  private handlePointerDown(coords: ICoords): void {
    if (this.canShoot(coords.hexSpace)) {
      this.board.shoot(coords.hexSpace);
    }
  }

  private canShoot(target: IPoint): boolean {
    if (window.game.gamePause || window.game.leaderboardOpened) return false;
    if (this.board.getData().state.gameOver) return false;
    const { position, angleLimitRad } = this.board.getData().shooter;
    const shootAngle = Math.abs(getAngle(position, target) + Math.PI * 0.5);
    return shootAngle <= angleLimitRad;
  }

  public update(): void {
    const coords = this.view.getInputCatcher().getCoords();
    if (this.canShoot(coords.hexSpace)) {
      this.view.displayTestShoot(this.board.testShoot(coords.hexSpace));
    }
  }
}